export type ApplicationName = 'carsys' | 'carcat'

const useApplicatioName = (): ApplicationName => {
  return window.origin.includes('carcat') ? 'carcat' : 'carsys'
}

export default useApplicatioName
